import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';
import { ReportCoverAction as CoverAction } from 'webapp/enums/enums';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';

export { CoverAction };
export interface Args {
	cover: string;
	handleCoverAction?: (action: CoverAction) => void;
}

export default class ReportsCoverPagelessComponent extends Component<Args> {
	@service('popup') declare popupService: Service.Popup;

	get canEditCover() {
		return this.args.handleCoverAction !== undefined;
	}

	@action
	openEditCover(): void {
		if (this.canEditCover) {
			this.args.handleCoverAction!(CoverAction.EDIT);
		}
	}
	<template>
		<div class="pageless-cover">
			<img src={{@cover}} alt="Pageless cover" class="pageless-cover__image" />
			{{#if this.canEditCover}}
				<a role="button" class="pageless-cover__edit" {{on "click" this.openEditCover}}>
					<CommonUiIconComponent @name="Pencil" @size="sm" />
					Edit cover
				</a>
			{{/if}}
		</div>
	</template>
}
